<template>
  <div class="modal-layer">
    <complete-modal></complete-modal>
    <select-modal></select-modal>
    <video-store-modal></video-store-modal>
    <works-modal></works-modal>
    <preview-image-modal></preview-image-modal>
    <preview-audio-modal></preview-audio-modal>
    <video-play-modal></video-play-modal>
    <message-dialog></message-dialog>
  </div>
</template>

<script>
import CompleteModal from '@/components/modal/completeModal';
import SelectModal from '@/components/modal/selectModal';
import WorksModal from '@/components/modal/worksModal';
import VideoStoreModal from '@/components/modal/videoStoreModal';
import PreviewImageModal from '@/components/modal/previewImageModal';
import PreviewAudioModal from '@/components/modal/previewAudioModal';
import VideoPlayModal from '@/components/modal/videoPlayModal';
import MessageDialog from '@/components/modal/messageDialog';

export default {
  components: {
    CompleteModal,
    SelectModal,
    WorksModal,
    VideoStoreModal,
    PreviewImageModal,
    PreviewAudioModal,
    VideoPlayModal,
    MessageDialog
  },
  data() {
    return {};
  },
  methods: {}
};
</script>

<style lang="scss" scoped>
.modal-layer {
  position: absolute;
  left: 0;
  top: 0;
  width: 0;
  height: 0;
  z-index: 1200;
}
</style>
